import React, { useEffect, useState } from 'react';
import { BsBarChartFill } from 'react-icons/bs';
import api from '../../../../api';
import { useAuth } from '../../../Layouts/context/Authcontext';
import { getRoundRobinBaseUrl } from '../../../../loadBalancer';
import {
  BsClockFill,
  BsFillCalendar2CheckFill,
  BsCpuFill,
} from 'react-icons/bs';

import {
  FaUserClock,
  FaRegCalendarCheck,
  FaPercent,
  FaBullseye,
  FaTachometerAlt,
  FaTasks,
  FaChartLine,
  FaChartPie,
  FaClipboardCheck,
  FaCheckCircle,
} from 'react-icons/fa';

import { MdSpeed, MdOutlineAccessTime } from 'react-icons/md';

const cardIcons = [
  <FaUserClock />,            // Total FTE Worked
  <BsClockFill />,            // Expected Hours
  <MdOutlineAccessTime />,    // Biometric Hours
  <BsCpuFill />,              // EPR Hours
  <BsFillCalendar2CheckFill />, // Worked days
  <FaChartLine />,            // Bio productivity
  <FaTachometerAlt />,        // Epr productivity
  <FaPercent />,              // Quality %
];

const cardTitles = [
  'Forecast ',
  'Budget',
  'MTD Target',
  'MTD Achieved',
  'MTD Differernce',
  'Expected',
//   'Epr productivity',
  'Over All Difference',
];

const RevenueTopCards = () => {
  const { accessToken } = useAuth();
  const [cardData, setCardData] = useState({});
  const [lastUpdated, setLastUpdated] = useState('--');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCardStats = async () => {
      try {
        setLoading(true);
        const baseUrl = getRoundRobinBaseUrl();

        const response = await api.get(`${baseUrl}/dashboard/top17Statistics`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });

        if (response.data && response.data.success) {
          setCardData(response.data.data || {});
          setLastUpdated(new Date().toLocaleString());
        }
      } catch (error) {
        console.error('Error fetching Top 17 card stats:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchCardStats();
  }, [accessToken]);

  const firstRowTitles = cardTitles.slice(0, 8);

  const renderCard = (title, index) => (
    <div
      key={index}
      className="bg-white rounded-xl border border-gray-200 shadow-sm p-5 hover:shadow-md transition-shadow w-full"
    >
      <div className="flex items-center gap-4 mb-4">
        <div className="bg-blue-100 text-blue-600 p-2 rounded-full">
          <span className="text-lg">{cardIcons[index]}</span>
        </div>
        <h2 className="text-sm font-semibold text-gray-700">{title}</h2>
      </div>
      <div className="text-3xl font-bold text-gray-900">
        {loading ? '...' : cardData[title] ?? '--'}
      </div>
      <p className="text-xs text-gray-400 mt-1">Last updated: {lastUpdated}</p>
    </div>
  );
  
  return (
    <div>
      {loading ? (
        <div className="flex justify-center items-center py-12">
          <div className="animate-spin rounded-full h-20 w-20 border-t-4 border-blue-500"></div>
        </div>
      ) : (
        <>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 xl:grid-cols-8 gap-4 mb-6 ml-36">
            {firstRowTitles.map((title, index) => renderCard(title, index))}
          </div>
        </>
      )}
    </div>
  );
};

export default RevenueTopCards;
